export class RestoreMicrosoft365UserDriveByEntityRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreScope",
            "baseName": "restoreScope",
            "type": "Microsoft365UserDriveRestoreScope",
            "format": ""
        },
        {
            "name": "selectedItems",
            "baseName": "selectedItems",
            "type": "Microsoft365UserDriveSelectedItemsOptions",
            "format": ""
        },
        {
            "name": "targetSaasEntityId",
            "baseName": "targetSaasEntityId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365UserDriveByEntityRequest.attributeTypeMap;
    }
    constructor() {
    }
}
